import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toEuros } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import { ExplicationSolde } from '../Accueil/CardInfos';
import Card from '../Card';

export const CercleSolde = ({ Solde }) => (
    <div className="m-3">
        <div className={`c100 p100 center medium ${Solde < 0 ? 'red' : 'green'} `}>
            <span>{toEuros(Solde, true)}€</span>
            <div className="slice">
                <div className="bar" />
                <div className="fill" />
            </div>
        </div>
    </div>
);

const CardCompte = ({ Solde, ComptaEnReprise_Visible, EtatGestion, EstMembreCS}) => (
    <Card Titre={CardCompte.titleName}>
        { ((ComptaEnReprise_Visible==0 && EtatGestion==1) || (ComptaEnReprise_Visible==2 && EtatGestion==1 && !EstMembreCS )) ?
            <React.Fragment>
                <div className="card-text mb-3">
                        <p style={{fontSize:"14px",fontWeight:"bold",padding:"20px 0 20px 20px"}}>Reprise comptable en cours.
                        <br/>L'accès aux informations est momentanément suspendu.</p>
                </div>
            </React.Fragment>
            :
            <React.Fragment>
                <div className="card-text mb-3">
                    <CercleSolde Solde={Solde} />
                    <ExplicationSolde Solde={Solde} />
                </div>
                <div className="d-flex flex-wrap">
                    <Link to="/MesInformations/MonHistorique" className="btn btn-outline-primary mt-2">
                        Voir mon historique comptable
                    </Link>
                    <Link to="/MesInformations/Paiement" className="btn btn-outline-orange ml-3 mt-2" title="Redirection vers la page de paiement">
                        Payer
                    </Link>
                </div>
            </React.Fragment> 
        }
    </Card>
);
CardCompte.displayName = 'CardCompte';
CardCompte.titleName = 'Mon solde';
CardCompte.requiredProps = [
    'Solde', // Solde du propriétaire
];

function mapStateToProps({
    AdhStore: { EstMembreCS },
    ProStore: {
        Pro: {
            Cpt: { Solde },
        },
    },
    SynStore: {
        Syn: {
            ComptaEnReprise_Visible,
        },
    },
    CopStore: {
        Cop: {
            EtatGestion,
        },
    },
}) {
    return {
        Solde, ComptaEnReprise_Visible, EtatGestion, EstMembreCS
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardCompte));



// WEBPACK FOOTER //
// ./src/components/MesInfos/CardCompte.js